"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-redeclare */
const Druid_1 = require("../../Druid");
const TypeGuard_1 = require("../../Types/TypeGuard");
function component(arg) {
    const url = typeof arg === 'string' ? arg : undefined;
    if (url !== undefined && url.startsWith('/') === false) {
        throw new Error(`@component('${url}'): url should start with '/'`);
    }
    const fn = (target) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        target.prototype.$url = url;
        // override class constructor to be able to mount after the parent view constructor
        const theClass = class extends target {
            constructor(...args) {
                super(...Druid_1.default.getContainer().applyInjections(target, args));
                if (TypeGuard_1.default.isMountable(this) === false) {
                    return;
                }
                try {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                    this.mount();
                }
                catch (e) {
                    // exception might be accidentally caught and suppressed by parent. Make sure it's printed
                    console.error(e);
                    throw e;
                }
            }
        };
        // if this component was already registered as an injectable, we need to upgrade its targetConstructor
        Druid_1.default.getContainer().getServicesWithConstructor(target).forEach(serviceRegistration => serviceRegistration.$targetConstructor = theClass);
        return theClass;
    };
    if (typeof arg === 'function') {
        return fn(arg);
    }
    return fn;
}
exports.default = component;
//# sourceMappingURL=Component.js.map